import { render, staticRenderFns } from "./DetailStoreGiftListComponent.vue?vue&type=template&id=31dcd28a&scoped=true&"
import script from "./DetailStoreGiftListComponent.vue?vue&type=script&lang=js&"
export * from "./DetailStoreGiftListComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailStoreGiftListComponent.vue?vue&type=style&index=0&id=31dcd28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dcd28a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
